var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel__body pt-4 ml-2 mr-2"},[(!_vm.preparation)?_c('ReportForm',{attrs:{"hasUi":true,"type":'report',"tableFields":_vm.tableFields,"form-fields":_vm.formFields,"category":_vm.category,"report-type":_vm.report_type,"report-types":[
            {
                id: 'penjualanstore',
                text: 'Penjualan Store '
            },
        ]}}):_c('div',{staticClass:"text-center text-primary py-14"},[_c('b-spinner',{staticClass:"align-middle",attrs:{"type":"grow","small":"","label":"Loading..."}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }